import { render } from "./DJAbnormalCallList.vue?vue&type=template&id=081b74f5&scoped=true"
import script from "./DJAbnormalCallList.vue?vue&type=script&lang=js"
export * from "./DJAbnormalCallList.vue?vue&type=script&lang=js"

import "./DJAbnormalCallList.vue?vue&type=style&index=0&id=081b74f5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-081b74f5"

export default script